import { Link, Outlet, createRootRoute } from "@tanstack/react-router";
import { auth } from "../lib/authManager";

export const Route = createRootRoute({
  // Resolve the session (refresh cookie → tokens) before any route decides.
  beforeLoad: async () => {
    await auth.bootstrap();
  },
  component: () => (
    <div className="rago-stage">
      <Outlet />
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="rago-stage flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <p className="rago-wordmark mb-8 text-xl">RAGO</p>
      <h1 className="rago-display mb-3 text-2xl">Something went sideways</h1>
      <p className="mb-8 max-w-md text-sm text-[var(--rago-text-2)]">
        {error instanceof Error ? error.message : "An unexpected error occurred."}
      </p>
      <button
        className="rago-btn rago-btn-fit"
        onClick={() => window.location.assign(import.meta.env.BASE_URL)}
      >
        Back to safety
      </button>
    </div>
  ),
  notFoundComponent: () => (
    <div className="rago-stage flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <p className="rago-wordmark mb-8 text-xl">RAGO</p>
      <h1 className="rago-display mb-3 text-2xl">Nothing here</h1>
      <p className="mb-8 text-sm text-[var(--rago-text-2)]">
        This page doesn't exist.
      </p>
      <Link to="/" className="rago-btn rago-btn-fit">
        Back home
      </Link>
    </div>
  ),
});
